var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5000 5000",
    style: {
      enableBackground: "new 0 0 5000 5000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4185.345,1204.773c-37.277,5.605-78.441,2.23-116.281,2.195l-2988.211-0.137 c-122.535-0.066-361.602,42.91-383.563-123.25c-15.363-116.25-20.105-290.133,130.231-308.043 c72.578-2.265,145.695-0.535,218.332-0.511l2954.457,0.05c103.101-0.226,272.585-30.758,302.762,105.45 c7.199,32.566,9.082,181.621,3.148,213.46C4295.333,1152.265,4241.232,1193.788,4185.345,1204.773L4185.345,1204.773z  M4185.345,1204.773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4069.771,1352.784l1.344-1.34L4069.771,1352.784z M4069.771,1352.784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.005,1353.456c49.406,4.797,100.934,2.172,150.59,2.168l2724.629,0.02c86.109-0.008,172.535,1.769,258.547-2.86 c-111.035,113.258-226.172,273.102-332.399,396.836l-835.57,975.188c-1.613,26,0.563,52.613,0.656,78.711l0.075,696.047 c0,79.222,3.148,159.347,0.613,238.425c-2.785,87.059-60.453,116.7-125.223,159.399l-362.371,238.722 c-38.902,26.172-78.293,56.446-119.84,78.172c-79.961,41.797-182.863-5.468-195.355-98.386c-5.594-41.629-2-87.989-1.977-130.129 l0.078-670.68c0-79.297-3.07-160.105,2.086-239.207c-7.222-116.355,4.324-233.789-4.754-349.949 c-54.937-77.883-124.906-147.563-186.629-220.313l-806.558-952.566C1048.13,1488.605,994.826,1412.89,936.005,1353.456 L936.005,1353.456z M936.005,1353.456"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.f5352d7153e8f49d33a16ffc7b742403.svg";
export { ForwardRef as ReactComponent };